import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-page">
      <div className="hero-section">
        <h1>🔴 链上抢红包系统</h1>
        <p className="hero-description">
          基于以太坊的去中心化红包系统，公平透明，安全可靠
        </p>
        <div className="hero-buttons">
          <Link to="/create" className="hero-button create-btn">
            💰 发红包
          </Link>
          <Link to="/claim" className="hero-button claim-btn">
            🎁 抢红包
          </Link>
        </div>
      </div>

      <div className="features-section">
        <h2>功能特点</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🔐</div>
            <h3>安全可靠</h3>
            <p>基于智能合约，代码开源，资金安全有保障</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>实时透明</h3>
            <p>所有交易记录上链，实时查看红包状态</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎲</div>
            <h3>公平随机</h3>
            <p>使用链上随机算法，确保分配公平</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🌐</div>
            <h3>去中心化</h3>
            <p>无需第三方，完全去中心化运行</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;

